// Central place for contact info. Easy to swap out later.
export const CONTACT = {
  brand: "in7sekunden",
  domain: "in7sekunden.de",
  email: "info@in7sekunden.de",
  // International E.164 for WhatsApp wa.me links
  whatsappNumber: "491725263514", // +49 172 5263514
  whatsappDisplay: "+49 172 5263514",
  whatsappUrl(message = "") {
    const base = `https://wa.me/${this.whatsappNumber}`;
    if (!message) return base;
    return `${base}?text=${encodeURIComponent(message)}`;
  },
};
